import * as types from "../actions/actionTypes";
import { SessionActions } from "../actions/guideStreamActions";

export default function sessionToActivateReducer(state = null, action: SessionActions) {
    switch (action.type) {
        case types.BEGIN_SESSION_SUCCESS:
            return {
                sessionId: action.sessionId,
                customerId: action.customerId,
            };
        default:
            return state;
    }
}
